var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var buildFormInitialValues = function (shops, tax) {
    var _a;
    var assignments = (_a = tax === null || tax === void 0 ? void 0 : tax.assignments) !== null && _a !== void 0 ? _a : [];
    var initialValues = assignments.reduce(function (memo, assignment) {
        var _a;
        var _b;
        return __assign(__assign({}, memo), (_a = {}, _a[assignment.ownerId] = {
            percentage: (_b = assignment.percentage) !== null && _b !== void 0 ? _b : tax.percentage,
            enabled: assignment.enabled,
        }, _a));
    }, {});
    // some shops might not be present in the assignments list
    // here we make sure they have a default value
    shops.forEach(function (shop) {
        var _a;
        if (!initialValues[shop.id]) {
            initialValues[shop.id] = {
                // 0 for the case when we are still fetching the tax and it's not available
                percentage: (_a = tax === null || tax === void 0 ? void 0 : tax.percentage) !== null && _a !== void 0 ? _a : 0,
                enabled: false,
            };
        }
    });
    return initialValues;
};
